export default __webpack_public_path__ + "static/media/330_dummy2016-musikschule01-de.8e09f4c2.png";